import { render, staticRenderFns } from "./DefaultContract.vue?vue&type=template&id=196b440d&scoped=true&"
import script from "./DefaultContract.vue?vue&type=script&lang=js&"
export * from "./DefaultContract.vue?vue&type=script&lang=js&"
import style0 from "./DefaultContract.vue?vue&type=style&index=0&id=196b440d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b440d",
  null
  
)

export default component.exports